/**
 * @Author: AI Assistant
 * @Date: 2025-07-02 15:42:00
 * @Description: 工作台路由配置
 */

const MenuLayout = () => import('@/components/layout/index.vue')
const Layout = () => import('@/views/index/index.vue')
export default {
  path: '/workbench',
  redirect: '/workbench/list',
  // 组件
  component: Layout,
  children: [
    // 工作台列表
    {
      path: 'list',
      component: MenuLayout,
      children: [
        {
          path: '',
          component: () => import('@/views/workbench/workbench/list/index.vue'),
          meta: {
            name: '工作台管理',
            context: 'workbench',
            type: 'INNER_APP',
            canAccess: true
          }
        },
        // 设计工作台
        {
          path: 'design',
          name: 'workbench-design',
          meta: {
            canAccess: true
          },
          component: () => import('@/views/workbench/workbench/design/index.vue')
        }
      ]
    },
    // 组件市场
    {
      path: 'component-market',
      component: MenuLayout,
      children: [
        // 组件列表
        {
          path: 'list',
          component: () => import('@/views/workbench/component-market/list/index.vue'),
          meta: {
            name: '组件列表',
            context: 'workbench',
            type: 'INNER_APP',
            canAccess: true
          }
        },
        // 组件分类
        {
          path: 'category',
          component: () => import('@/views/workbench/component-market/category/index.vue'),
          meta: {
            name: '组件分类',
            context: 'workbench',
            type: 'INNER_APP'
          }
        }
      ]
    },
    // 角色管理
    {
      path: 'role-manage',
      component: MenuLayout,
      children: [
        {
          path: '',
          component: () => import('@/views/workbench/role-manage/index.vue'),
          meta: {
            name: '角色管理',
            context: 'workbench',
            type: 'INNER_APP'
          }
        }
      ]
    }
  ]
}
